export default __webpack_public_path__ + "slices/main/assets/public/media/logo-bar-invision@2x.97bb2a9eecd072a9702d05e9874f11af.png";